<div class="qvs-spinner-centered">
  <ion-spinner color="primary"></ion-spinner>
</div>
